import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Button } from 'primeng/button';

@Component({
  selector: 'lh-critical-error',
  standalone: true,
  imports: [Button],
  template: `
    <div class="critical-error">
      <h2 class="critical-error__header">
        Oops! Something went wrong while loading the app. Please reload the page and try again.
      </h2>
      <p-button label="Try Again" (click)="reloadPage()" />
      <span class="critical-error__support">
        If the issue persists, contact
        <a class="critical-error__link" href="mailto:support@leasehawk.com">support&#64;leasehawk.com</a> for
        assistance.
      </span>
    </div>
  `,
  styleUrls: ['./critical-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CriticalErrorComponent {
  @Input() message: string = 'Oops! Something went wrong while loading the app. Please reload the page and try again.';

  reloadPage(): void {
    window.location.reload();
  }
}
